import { render, staticRenderFns } from "./EmployeeData.vue?vue&type=template&id=533279ec&scoped=true&"
import script from "./EmployeeData.vue?vue&type=script&lang=js&"
export * from "./EmployeeData.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeData.vue?vue&type=style&index=0&id=533279ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533279ec",
  null
  
)

export default component.exports